import { createFileRoute } from "@tanstack/react-router";

import { PreferencesPage } from "../iam/account/components/PreferencesPage";

/**
 * Route is /account/preferences: language, units, and communication. The account
 * layout (/_app/account) validates and owns the Ory settings `flow` search param —
 * the page reads the loaded flow from context (the newsletter preference is an Ory
 * self-service settings submit), so the route itself needs no search schema.
 */
export const Route = createFileRoute("/_app/account/preferences")({
  component: PreferencesPage,
});
